import { useLocation } from 'react-router-dom'
import { useTrayManagementContext } from './TrayManagement/TrayManagement.context'
import { useEffect } from 'react'

const useTrayManagementLayoutLogic = () => {
  const { pathname } = useLocation()
  const {
    snackbarOpen,
    snackbarIcon,
    snackbarMessage,
    snackbarState,
    handleSnackbarClose,
  } = useTrayManagementContext()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return {
    snackbarOpen,
    snackbarIcon,
    snackbarMessage,
    snackbarState,
    handleSnackbarClose,
  }
}

export default useTrayManagementLayoutLogic
